export default{
    
    lista:{
        method:'get',
        url:'trabalhador/anota/lista'
    },
    pesquisa:{
        method:'get',
        url:'boletins/tabela/pesquisa{/id}'
    },
    cadastra:{
        method:'post',
        url:'trabalhador/anota/cadastro'
    },
    delete:{
        method:'delete',
        url:'trabalhador/anota/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'trabalhador/anota/editar{/id}'
    },
    update:{
        method:'post',
        url:'trabalhador/anota/update'
    },
    duplicar:{
        method:'post',
        url:'arquivo/ferramenta/duplicar'
    },

    deletearquivo:{
        method:'delete',
        url:'arquivo/deletar{/id}'
    },
    updatearquivo:{
        method:'post',
        url:'arquivo/update'
    },
    compacta:{
        method:'post',
        url:'arquivo/ferramenta/compacta'
    },
    baixa:{
        method:'post',
        url:'arquivo/ferramenta/baixa'
    },
    cadastraarquivo:{
        method:'post',
        url:'arquivo/cadastro'
    },
    arquivoemil:{
        method:'post',
        url:'arquivo/ferramenta/email'
    },
    

}